import { FC } from "react";
import { TabIndexSettingsButton } from "../action/MainCollection";

interface ITabIndexSettingsButtonProps {
    disabled?: boolean;
    modalWindow: JSX.Element | null;
    showModal: () => void
}

export const TabIndexSettingsButtonModal: FC<ITabIndexSettingsButtonProps> = (props) => {
    
    return (
        <>
            <TabIndexSettingsButton 
                disabled={props.disabled}
                sizeVariant="normal" 
                onClick={() => props.showModal()}
            />
            {props.modalWindow}
        </>
    )
}